/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MdmBootstrapFieldMismatchEntryDto } from './MdmBootstrapFieldMismatchEntryDto';
import {
    MdmBootstrapFieldMismatchEntryDtoFromJSON,
    MdmBootstrapFieldMismatchEntryDtoFromJSONTyped,
    MdmBootstrapFieldMismatchEntryDtoToJSON,
    MdmBootstrapFieldMismatchEntryDtoToJSONTyped,
} from './MdmBootstrapFieldMismatchEntryDto';

/**
 * 
 * @export
 * @interface MdmBootstrapFieldMismatchReportDto
 */
export interface MdmBootstrapFieldMismatchReportDto {
    /**
     * 
     * @type {boolean}
     * @memberof MdmBootstrapFieldMismatchReportDto
     */
    success?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MdmBootstrapFieldMismatchReportDto
     */
    mismatchCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MdmBootstrapFieldMismatchReportDto
     */
    runtimeAliasApplied?: boolean;
    /**
     * 
     * @type {Array<MdmBootstrapFieldMismatchEntryDto>}
     * @memberof MdmBootstrapFieldMismatchReportDto
     */
    mismatches?: Array<MdmBootstrapFieldMismatchEntryDto>;
    /**
     * 
     * @type {string}
     * @memberof MdmBootstrapFieldMismatchReportDto
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmBootstrapFieldMismatchReportDto
     */
    errorMessage?: string;
}

/**
 * Check if a given object implements the MdmBootstrapFieldMismatchReportDto interface.
 */
export function instanceOfMdmBootstrapFieldMismatchReportDto(value: object): value is MdmBootstrapFieldMismatchReportDto {
    return true;
}

export function MdmBootstrapFieldMismatchReportDtoFromJSON(json: any): MdmBootstrapFieldMismatchReportDto {
    return MdmBootstrapFieldMismatchReportDtoFromJSONTyped(json, false);
}

export function MdmBootstrapFieldMismatchReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmBootstrapFieldMismatchReportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'mismatchCount': json['mismatchCount'] == null ? undefined : json['mismatchCount'],
        'runtimeAliasApplied': json['runtimeAliasApplied'] == null ? undefined : json['runtimeAliasApplied'],
        'mismatches': json['mismatches'] == null ? undefined : ((json['mismatches'] as Array<any>).map(MdmBootstrapFieldMismatchEntryDtoFromJSON)),
        'message': json['message'] == null ? undefined : json['message'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function MdmBootstrapFieldMismatchReportDtoToJSON(json: any): MdmBootstrapFieldMismatchReportDto {
    return MdmBootstrapFieldMismatchReportDtoToJSONTyped(json, false);
}

export function MdmBootstrapFieldMismatchReportDtoToJSONTyped(value?: MdmBootstrapFieldMismatchReportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'mismatchCount': value['mismatchCount'],
        'runtimeAliasApplied': value['runtimeAliasApplied'],
        'mismatches': value['mismatches'] == null ? undefined : ((value['mismatches'] as Array<any>).map(MdmBootstrapFieldMismatchEntryDtoToJSON)),
        'message': value['message'],
        'errorMessage': value['errorMessage'],
    };
}

